import { Button, Form, Input, message, Modal, Space, Typography } from "antd";
import React, { useCallback, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import StatementTitlesTable from "../statementTitlesTable/StatementTitlesTable";
import { StatementTitlesTableProvider } from "../../../context/StatementTitlesTableContext";
import { useArchiveTitlesMutation } from "../../../redux/api/reconciliationsApiSlice";
import { isEmpty } from "lodash";
import { mergeTitles } from "./CreateStandardRemittanceModalButton";
import { StatementTitle } from "../../../types/reconciliation";

const { Title } = Typography;

export const CreateArchivedRemittanceModalButton = () => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [open, setOpen] = useState(false);
  const [showConfirmedTitles, setShowConfirmedTitles] = useState(false);
  const [selectedTitles, setSelectedTitles] = useState<StatementTitle[]>([]);
  const [selectedTitlesPage, setSelectedTitlesPage] = useState<number>(1);

  const [archiveTitles, { isLoading }] = useArchiveTitlesMutation();

  const handleCreationModalClose = useCallback(() => {
    form.resetFields();
    setSelectedTitles([]);
    setOpen(false);
    setShowConfirmedTitles(false);
  }, [form]);

  return <>
    {contextHolder}
    <Modal
      open={open}
      title={"Crea rimessa"}
      onCancel={handleCreationModalClose}
      okText={!isEmpty(selectedTitles) ? `Conferma titoli (${selectedTitles.length}) e crea rimessa` : "Conferma titoli e crea rimessa"}
      width={"90dvw"}
      footer={
        <Space size={"small"}>
          <Button
            onClick={handleCreationModalClose}>
            Annulla
          </Button>
          <Button
            disabled={isEmpty(selectedTitles)}
            onClick={() => {
              setSelectedTitlesPage(1);
              setShowConfirmedTitles(show => !show);
            }}>
            {showConfirmedTitles ? "Vedi tutti i titoli" : "Vedi titoli selezionati"}
          </Button>
          <Button
            disabled={isEmpty(selectedTitles) || isLoading}
            loading={isLoading}
            type={"primary"}
            onClick={() => {
              form.validateFields().then((values) => {
                archiveTitles({
                  name: values.name,
                  notes: values.notes ?? "",
                  statement_titles: selectedTitles.map(s => s.uuid)
                }).unwrap()
                  .then(() => {
                    handleCreationModalClose();
                  }).catch((err) => {
                  console.error("could not confirm titles due to an error: ", err);
                  messageApi.error("Errore nell'archiviazione dei titoli");
                });
              });
            }}
          >{!isEmpty(selectedTitles) ? `Conferma e archivia titoli (${selectedTitles.length}) ` : "Conferma e archivia titoli"}</Button>
        </Space>
      }
    >
      <Form name={"confirmTitlesForm"} layout={"vertical"} form={form} style={{ maxWidth: 600 }}>
        <Form.Item name={"name"} label={"Nome rimessa:"} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name={"notes"} label={"note:"}>
          <Input.TextArea />
        </Form.Item>
      </Form>
      <Title level={5}>{showConfirmedTitles ? "Titoli selezionati" : "Titoli broker"}</Title>
      <StatementTitlesTableProvider>
        <StatementTitlesTable
          tableProps={showConfirmedTitles ? { dataSource: selectedTitles,
            pagination: {
              total: selectedTitles.length,
              showTotal: (total, range) => `${range[0]}-${range[1]} di ${total} titoli`,
              current: selectedTitlesPage,
              onChange: (page, pageSize) => {
                setSelectedTitlesPage(page);
              }
            }
          } : {}}
          defaultFilters={{ confirmed: "false" }}
          showReconciliationColumns={true}
          useStatementsTitlesGroup={false}
          rowsSelectable={true}
          allRowsSelectable={true}
          selectedRows={selectedTitles.map(statement => statement.uuid)}
          onSelectedRowsChange={(keys, records) => {
            const filteredTitles = selectedTitles.filter(title => keys.includes(title.uuid));
            const allTitles = mergeTitles(filteredTitles, records.filter(Boolean));
            setSelectedTitles(allTitles);
          }} />
      </StatementTitlesTableProvider>
    </Modal>
    <Button type={"primary"} onClick={() => {
      setOpen(true);
    }} icon={<PlusOutlined />}>Crea rimessa da archiviare</Button>
  </>;
};